<template>
  <div class="flex flex-col items-center gap-y-5">
    <Header label="Job Tracker Images" />    
    <div class="flex flex-row">
      <input @keyup.enter="lookupJob" v-model="jobId" ref="input" type="text" placeholder="Job #" class="p-2 border rounded-sm">
      <Button label="Lookup Job" @click="lookupJob" />    
    </div>

    <div v-if="lookedUpJob.status" class="bg-white rounded-sm flex flex-col justify-start gap-y-2 w-full max-w-screen-sm">
      <div class="flex flex-row items-center justify-between p-2">
        <div class="font-game text-lg">Job {{lookedUpJob.id}}</div>
        <Button label="Add Image" @click="showUploadForm()" />
      </div>  
      <!--Upload Bar-->
      <div v-if="showUpload" class="w-2/3 rounded-sm mx-auto bg-gray-200 flex flex-col gap-y-2 p-2">
    <div v-if="uploadStatus">{{ uploadStatus }}</div>
        <div class="font-desc font-bold">Uploading image to job {{lookedUpJob.id}}</div>
        <input v-model="seq" ref="inputSeq" type="text" placeholder="Seq #" class="p-2 border rounded-sm"> 
    <input type="file" @change="onFileChange" accept="image/*" />
        <div class="w-full flex flex-row">
          <Button label="Upload" class="w-3/4" @click="uploadImage" :disabled="!selectedFile" />
          <Button label="Cancel" class="w-1/4" color="red" @click="showUpload = false" />
        </div>
      </div>
      <!--Directory not found-->
      <div v-if="lookedUpJob.status == 'error'">No Job Images Found</div>
      <!--List directories-->
      <div v-for="dir in lookedUpJob.subdirectories" :key="dir" 
        :class="`${showUpload && seq != dir.seq || focusedImage && focusedImageSeq != dir.seq ? 'hidden' : ''} flex flex-col`">
        <div :class="`w-full bg-gray-300 p-2 justify-between flex flex-row items-center`">
          <span class="font-bold font-game">SEQ-{{dir.seq}} Images</span>
          <Button v-if="!showUpload" label="Add Image" @click="showUploadForm(dir.seq)" />
        </div>
        <div v-if="focusedImage" class="p-2">
          <div class="flex flex-row justify-between items-center p-2">
            <span>{{focusedImage}}</span>
            <Button @click="focusedImage = ''" label="X" color="red" />
          </div>
          <img class="w-full rounded-sm"
            :src="`https://img.vector8.xyz/ami/tracker/${focusedImage}`"/>
            <Button @click="deleteImage(focusedImage);focusedImage = '';" label="Delete Image" color="red" />
        </div>
        <div v-else class="w-full flex flex-row">
          <div v-for="img in dir.images" :key="img"
            class="p-3 rounded-sm border w-64">
            <img :src="`https://img.vector8.xyz/ami/tracker/${img}`" 
              @click="focusedImage = img"
              class="cursor-zoom-in" />
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>

<script>
import { ref } from 'vue'

import Button from '@/components/Button.vue'
import Header from '@/components/Header.vue'

export default {
  data() {
    return {
      customText: '',
      imageUrl: '' // URL for the generated image
    };
  },
  components: {
    Button,
    Header
  },
  mounted(){
  },
  computed: {
    focusedImageSeq(){
      if(!this.focusedImage || this.focusedImage.indexOf('/') == -1) return '';
      return this.focusedImage.split('/')[2];
    }
  },
  methods: {
  async deleteImage(imagePath) {
        fetch(`https://w.vector8.xyz/tracker_delete.php?imagePath=${imagePath}`, {
          method: 'GET',  // For now, we are using GET to match the debugging-friendly PHP version
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === 'success') {
            console.log('Image deleted successfully.');
          } else {
            console.log('Error:', data.message);
          }

          //Run lookup again to refresh images
          this.lookupJob()
        })
        .catch(error => {
          console.error('Error deleting image:', error);
        });

    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    async uploadImage() {
      if (!this.selectedFile) return;

      const formData = new FormData();
      formData.append('image', this.selectedFile);
      formData.append('job', this.lookedUpJob.id);  // Replace with dynamic jobId
      formData.append('seq', this.$refs.inputSeq.value);    // Replace with dynamic seqId

      try {
        const response = await fetch('https://w.vector8.xyz/tracker_upload.php', {
          method: 'POST',
          body: formData,
        });
        const data = await response.json();

        if (data.status === 'success') {
          this.uploadStatus = 'Upload successful!';
          //Run lookup again to refresh images
          this.lookupJob()
        } else {
          this.uploadStatus = 'Upload failed: ' + data.message;
        }
      } catch (error) {
        this.uploadStatus = 'An error occurred: ' + error.message;
      }
    },
    fetchJobDetails(jobId){  
        return new Promise(resolve => {
            fetch(`https://w.vector8.xyz/job_tracker.php?job=${jobId}`, {
                method: 'GET'
                })
                .then(res => res.json())
                .then(data => {
                    this.lookedUpJob = data;
                })
                .catch(error => {
                  console.log('error: ', error)
                    resolve(false);
                })               
        });
    },    
    async lookupJob(){
      console.log('lookupJob: ', this.job, this.seq);
      let jobDetails = await this.fetchJobDetails(this.jobId);
      console.log('jobDetails: ', jobDetails)
    },
    async showUploadForm(seqId){
      if(seqId)
        this.seq = seqId
      
      this.showUpload = true;
      await new Promise(r => setTimeout(r, 1));
      if(this.$refs.inputSeq) 
      this.$refs.inputSeq.focus()

    }
  },
  setup(){

    let focusedImage = ref('')
    let jobId = ref('')
    let seq = ref('')
    let lookedUpJob = ref({})
    let showUpload = ref(false)

    return {
      focusedImage,
      jobId, 
      lookedUpJob,
      seq,
      showUpload
    }


  }
};
</script>